import React from "react";
import Button from "ComponentsUI/Button";
import withStyles from "react-jss";
import FilterCollapseWrapper from "../FiltersCollapseWrapper";
import { Fade } from "ComponentsUI/Fade";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
		},
		wrapperList: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "flex-start",
			justifyContent: "flex-start",
		},
		mobileButton: {
			display: "none",
		},
		wrapper: {
			position: "relative",
		},
		wrapperIsOpen: {},
		close: {
			display: "none",
			cursor: "pointer",
			width: "50px",
			height: "50px",
			borderRadius: "50%",
			backgroundColor: theme.palette.colors.white,
			border: `1px solid ${theme.palette.colors.cloudyBlue}`,
			boxShadow: `0 2px 4px 0 rgba(44, 29, 93, 0.3)`,
			position: "absolute",
			top: 0,
			transform: "translateY(-50%)",
			right: "20px",
			justifyContent: "center",
			alignItems: "center",
			"& span": {
				color: theme.palette.colors.cloudyBlue,
				fontSize: "20px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			wrapper: {
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				backgroundColor: "white",
				padding: "32px 0",
				transform: "translateY(200%)",
				borderTop: `1px solid ${theme.palette.colors.cloudyBlue}`,
				transition: "transform ease-out .3s",
			},
			wrapperIsOpen: {
				transform: "translateY(0)",
			},
			wrapperList: {
				marginTop: 0,
			},
			mobileButton: {
				display: "block",
			},
			close: {
				display: "flex",
			},
		},
	};
};

class FilterCollapseWithButtonChange extends React.Component {
	constructor(props) {
		super(props);
		let text = props.text;
		this.showFiltersText = text.SHOW_ALL_FILTERS;
		this.hideFiltersText = text.HIDE_FILTERS;
		this.state = {
			open: false,
			showResetButton: false,
		};
	}

	changeOpenState(value) {
		this.setState({
			open: value,
		});

		this.props.changeOpenState(value);
	}

	render() {
		let classes = this.props.classes;

		return (
			<div className={classes.root}>
				<div className={classes.mobileButton}>
					{this.state.showResetButton && this.props.haveUrlFilters ? (
						<Button
							fullWidth={true}
							noPaddings={true}
							transparent={true}
							status={"secondaryAccent"}
							size="always50"
							typeText={"verybig"}
							onClick={() => {
								this.setState({ showResetButton: false });
								this.props.resetFiltersHandler();
							}}
						>
							<span>{this.props.text.RESET_FILTERS}</span>
						</Button>
					) : (
						<Button
							fullWidth={true}
							noPaddings={true}
							transparent={true}
							status={"secondaryAccent"}
							size="always50"
							typeText={"verybig"}
							onClick={() => this.changeOpenState(true)}
						>
							<span
								className="icon24 icon-config-1"
								style={{
									fontSize: "24px",
									marginRight: "24px",
								}}
							/>
							<span>{this.props.text.FILTER}</span>
						</Button>
					)}
				</div>
				<div className={"onlyXs"}>{this.state.open && <Fade />}</div>
				<FilterCollapseWrapper
					text={this.props.text}
					windowSizes={this.props.windowSizes}
					resetFiltersHandler={this.props.resetFiltersHandler}
					withoutResetButton={this.props.withoutResetButton}
					changeOpenState={(value) => {
						this.changeOpenState(value);
					}}
					open={this.state.open}
					isProviderCard={this.props.isProviderCard}
					twoHiddenFilters={this.props.twoHiddenFilters}
					disableResetFilterButton={this.props.disableResetFilterButton}
					applyButtonClick={() => {
						this.setState({ showResetButton: true });
					}}
				>
					{this.props.children}
				</FilterCollapseWrapper>
			</div>
		);
	}
}

export default withStyles(styles)(FilterCollapseWithButtonChange);
